export default __webpack_public_path__ + "static/media/island.47cd70c7.jpg";